import React from "react";

const DeleteConfirmModal = ({
    show,
    title = "Delete Confirmation",
    message = "Are you sure you want to delete this record?",
    onClose,
    onConfirm
}) => {

    if (!show) return null;

    return (

        <div
            className="modal d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >

            <div className="modal-dialog modal-dialog-centered">

                <div className="modal-content">

                    <div className="modal-header bg-danger text-white">

                        <h5 className="modal-title">

                            {title}

                        </h5>

                        <button
                            type="button"
                            className="btn-close btn-close-white"
                            onClick={onClose}
                        ></button>

                    </div>

                    <div className="modal-body">

                        <p className="mb-0">

                            {message}

                        </p>

                    </div>

                    <div className="modal-footer">

                        <button
                            className="btn btn-secondary"
                            onClick={onClose}
                        >

                            Cancel

                        </button>

                        <button
                            className="btn btn-danger"
                            onClick={onConfirm}
                        >

                            Delete

                        </button>

                    </div>

                </div>

            </div>

        </div>

    );

};

export default DeleteConfirmModal;